// src/components/ui/StepBar.jsx
//
// Where the user is in a multi-step process, shown in WizardModal's header. PROGRESS ONLY — the steps are not
// buttons: moving between them is the footer's Indietro / Avanti, so a step's checks can never be skipped.
// `steps` = [{ key, label }], `current` = a key. The current step carries aria-current="step"; done steps a
// check mark. Theme tokens only.
import React from 'react';
import { Check } from 'lucide-react';
import { COLORS, FONT_SANS, RADII } from '../../constants/theme.js';

const LIST = {
  display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px 18px',
  listStyle: 'none', margin: '14px 0 0', padding: 0, fontFamily: FONT_SANS,
};
const ITEM = { display: 'flex', alignItems: 'center', gap: '8px' };
const dot = (state) => ({
  width: '22px', height: '22px', flexShrink: 0, borderRadius: RADII.pill,
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  fontSize: '12px', fontWeight: 700,
  background: state === 'todo' ? COLORS.surface : COLORS.accent,
  color: state === 'todo' ? COLORS.textSecondary : COLORS.surface,
  border: `1px solid ${state === 'todo' ? COLORS.borderStrong : COLORS.accent}`,
  opacity: state === 'done' ? 0.75 : 1,
});
const label = (state) => ({
  fontSize: '13px',
  fontWeight: state === 'current' ? 700 : 500,
  color: state === 'todo' ? COLORS.textSecondary : COLORS.ink,
});

export default function StepBar({ steps, current, label: listLabel }) {
  const at = Math.max(0, steps.findIndex((s) => s.key === current));
  return (
    <ol aria-label={listLabel} style={LIST}>
      {steps.map((s, i) => {
        const state = i < at ? 'done' : i === at ? 'current' : 'todo';
        return (
          <li key={s.key} aria-current={state === 'current' ? 'step' : undefined} style={ITEM}>
            <span aria-hidden="true" style={dot(state)}>
              {state === 'done' ? <Check size={12} /> : i + 1}
            </span>
            <span style={label(state)}>{s.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
